export default {
    data: function () {
        return {
            //
        }
    },
    methods: {
        deleteElement: function () {
            EaseEventBus.fire('deleteElement', {
                id: this.index
            });
        }
    }
};
